<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Child route (New / Preview / Saved document) -->
      <router-view />
      <!-- end: Child route -->

      <!-- begin: Popup แนบไฟล์เอกสาร (F08) -->
      <!-- วางนอก v-show ของ portlet — bootstrap modal เปิดไม่ได้ถ้า parent เป็น display:none -->
      <!-- ปิด popup แล้ว component emit "closed" → reload ตารางให้สีปุ่มแนบไฟล์ (แดง/เขียว) ตรงกับจำนวนไฟล์จริง -->
      <form-summary-stock-attachment-modal
        ref="attachmentModal"
        @closed="reloadDataTable()"
      />
      <!-- end: Popup แนบไฟล์เอกสาร -->

      <div
        v-show="$route.path == '/PrintSummary/Barcodes'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-file-alt"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <!-- ลำดับแถบค้นหาตาม CR-Features.md F02 (spec ฉบับเซ็น 16/09/2026):
                   บรรทัดที่ 1 = ตัวแทนจำหน่าย + สถานะแนบไฟล์เอกสาร
                   บรรทัดที่ 2 = ช่วงวันที่บันทึก + อายุ Export Excel
                 ของเดิมสลับกันอยู่ (วันที่ขึ้นก่อน) — FS-004 ให้จัดใหม่ให้ตรง spec รอบเดียว
                 ทุกช่องใช้ col-xl-4 เท่ากันหมด เพื่อให้ช่องของ 2 บรรทัดตรงคอลัมน์กัน
                 FS-014 เพิ่ม "ค้นหาเลขเอกสาร" เป็นช่องแรกของบรรทัดที่ 1 (ผู้ใช้ขอ 24/09/2026)
                 บรรทัดที่ 1 จึงเป็น 3 × col-xl-4 = 12/12 พอดี ไม่ตกบรรทัด และไม่ต้องขยับบรรทัดที่ 2 -->
            <div class="row">
              <!-- FS-014 — filter "ค้นหาเลขเอกสาร" (คำขอเพิ่มจากผู้ใช้ 24/09/2026 · ไม่ได้อยู่ใน spec ฉบับเซ็น 16/09/2026)
                   ผู้ใช้ขอให้วางไว้ "ก่อนช่องตัวแทนจำหน่าย" จึงเป็นช่องแรกสุดของแถบค้นหา
                   ใช้ input text + v-model ธรรมดา ตาม pattern ที่ระบบใช้กับงานแบบเดียวกันเป๊ะ
                   (SBP.Web/App/Components/BudgetPlan/BudgetPlanJobList.vue:126-137 — "ค้นหาเลขที่ใบงาน")
                   ⚠ ห้ามทำช่องนี้เป็นปุ่ม (button) หรือใส่ aria-label ที่มีคำว่า "ค้นหา"
                     Playwright จับชื่อปุ่มแบบ substring ถ้ามี role=button อีกตัวที่ชื่อมีคำนี้
                     จะชนกับปุ่ม "ค้นหา" เดิม → strict mode violation → UI-5 / UI-16 ตกทันที
                     input + label ธรรมดามี role = textbox จึงไม่ชน -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ค้นหาเลขเอกสาร :</label>
                  <input
                    type="text"
                    class="form-control"
                    id="fssList_documentNo"
                    name="fssList_documentNo"
                    v-model="searchDocumentNo"
                    placeholder="เช่น DB2026-06001"
                    autocomplete="off"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'fssList_agentCode'"
                    :name="'fssList_agentCode'"
                    :select2-options="agentOptions"
                    v-model="searchAgentCode"
                    ref="fssList_agentCodeSelect2"
                  ></select2>
                </div>
              </div>
              <!-- FS-004 — filter "สถานะแนบไฟล์เอกสาร" (ค่าเริ่มต้น "ทั้งหมด")
                   use case หลัก: ตามงานว่าเอกสารใบไหนยังไม่ได้แนบไฟล์ที่เซ็นกลับมา
                   ไม่ใส่สี/สัญลักษณ์ในตัวเลือก (ต่างจาก filter อายุ Export Excel ที่ spec สั่งไว้)
                   เพราะสถานะนี้มีปุ่มแนบไฟล์แดง/เขียวในแถวบอกอยู่แล้ว -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>สถานะแนบไฟล์เอกสาร :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'fssList_attachmentStatus'"
                    :name="'fssList_attachmentStatus'"
                    :select2-options="attachmentStatusOptions"
                    v-model="searchAttachmentStatus"
                    ref="fssList_attachmentStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <!-- FS-057 — label ตาม mockup ของ spec (เดิม วันที่บันทึก (จาก)) -->
                  <label>วันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="fssList_dateFrom"
                      name="fssList_dateFrom"
                      ref="fssList_dateFrom"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <!-- FS-057 — label ตาม mockup ของ spec (เดิม วันที่บันทึก (ถึง)) -->
                  <label>วันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="fssList_dateTo"
                      name="fssList_dateTo"
                      ref="fssList_dateTo"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- F09 — filter "อายุ Export Excel" 4 สถานะ (ค่าเริ่มต้น "ทั้งหมด")
                   สี/สัญลักษณ์ใช้เฉพาะในตัวเลือกของ filter เท่านั้น ไม่ใช้กับข้อความในแถว -->
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>อายุ Export Excel :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'fssList_excelExpiryStatus'"
                    :name="'fssList_excelExpiryStatus'"
                    :select2-options="excelExpiryStatusOptions"
                    v-model="searchExcelExpiryStatus"
                    ref="fssList_excelExpiryStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <!-- FS-077 — ปุ่มธรรมดาแบบ /Jobs · loading ใช้ overlay บังฟอร์ม (ดู preXhr.dt / xhr.dt) -->
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-test="fss-list-search"
                >
                  ค้นหา
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างข้อมูล
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  v-if="canEdit"
                  type="button"
                  class="btn btn-primary"
                  @click="goToCreate"
                >
                  <i class="fas fa-plus"></i> เพิ่มสรุปสินค้าคงค้าง
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="formSummaryStockTable"
              >
                <!-- FS-084 — คอลัมน์ "คำสั่ง" กว้างคงที่ 230px พอดีเนื้อหา (ปุ่มวงกลม 5×28 + gap = 164px ·
                     บรรทัดหมดอายุ ~180px) เหลือขอบซ้าย-ขวาข้างละ ~25px · เดิม 27% ตั้งไว้ตอนปุ่มยังมีข้อความ (FS-005)
                     FS-089 — 4 คอลัมน์แรก 12/13/38/37%: เลขที่เอกสารกับวันที่ยาวคงที่ จึงบีบให้พอดีข้อความ
                     แล้วโยกพื้นที่ไปให้ "ผู้สร้าง" (ชื่อยาวเคยตัด 2 บรรทัด)
                     ค่าต้องตรงกับ width ใน options.columns ด้านล่างเสมอ ไม่งั้น DataTables จะคำนวณเพี้ยน -->
                <thead>
                  <tr>
                    <th class="all text-center" style="width: 12%;">เลขที่เอกสาร</th>
                    <th class="all text-center" style="width: 13%;">วันที่บันทึก</th>
                    <th class="all text-center" style="width: 38%;">ตัวแทนจำหน่าย</th>
                    <th class="all text-center" style="width: 37%;">ผู้สร้าง</th>
                    <th class="all text-center" style="width: 230px;">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)
import "./form-summary-stock-actions.css";
// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)
import { installFssTooltips } from "./form-summary-stock-tooltips";
installFssTooltips();
import axios from "axios";
import moment from "moment";
import router from "../../router";
import select2 from "../../Shared/Select2";
import DatatableWarning from "../../Shared/DatatableWarning";
import FormSummaryStockAttachmentModal from "./FormSummaryStockAttachmentModal";

require("datatables.net-bs4");
require("datatables.net-responsive-bs4");
require("sweetalert2");

// FS-077 — overlay "กำลังค้นหาข้อมูล..." ต้องค้างอย่างน้อยเท่านี้ (ms)
const SEARCH_MIN_LOADING_MS = 1000;

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F02 — หน้า "ค้นหาใบงาน" (/PrintSummary/Barcodes)
//
// Template ที่ mirror: SBP.Web/App/Components/StockCoverDays/StockCoverDaysList.vue
//   (worktree scvd-dev) — root v-show ตาม route + <router-view/> พี่น้องกัน, kt-portlet head/body,
//   form.kt-form ref="searchForm", <table> ที่มีแต่ <thead> ให้ DataTables เติม body,
//   server-side DataTable, Vue.extend mini-component ต่อแถวที่ mount ตอน draw.dt,
//   KTApp.block/unblock ที่ preXhr.dt/xhr.dt, DatatableWarning.alert ที่ error.dt
//   และ flow ยืนยันด้วย SweetAlert2 → axios → reloadDataTable()
//
// SweetAlert2 = ^8.2.3 (SBP.Web/package.json) → ใช้ option ชื่อ `type` (ไม่ใช่ `icon` ของ v9+)
// และอ่านผลจาก `result.value`
//
// spec ฉบับลูกค้าเซ็นยืนยัน 16/09/2026 เพิ่มในหน้านี้:
//   F02 — filter "สถานะแนบไฟล์เอกสาร" (ทั้งหมด / มีเอกสารแนบ / ไม่มีเอกสารแนบ)
//         + ปุ่มคำสั่ง 5 ปุ่มเป็น "ปุ่มมีข้อความ" ไม่ใช่ไอคอนล้วน (จัด 2 บรรทัด)
//   F09 — filter "อายุ Export Excel" 4 สถานะ + บรรทัด "หมดอายุ Export Excel" ทุกแถว
//         + ปุ่ม Excel เทากดไม่ได้เมื่อรายละเอียดบาร์โค้ดหมดอายุ (พร้อม tooltip)
//   F16 — ปุ่มลบแสดงตาม data.canDelete ที่ server คำนวณมา (แอดมินตัวแทนลบใบที่
//         แอดมินทีมเบียร์สดสร้างไม่ได้) — การซ่อนปุ่มเป็นแค่ UX ฝั่ง API บังคับซ้ำเสมอ
// ─────────────────────────────────────────────────────────────────────────────

// รูปแบบวันที่ที่ backend รับ (FormSummaryStockDatatable.DateFrom/DateTo = "dd/MM/yyyy")
const DATE_FORMAT = "DD/MM/YYYY";

// ปุ่มที่ยังไม่ถึงคิวพัฒนา — แจ้งผู้ใช้เป็นภาษาไทยแทนการเงียบ (ห้ามใช้ alert()/console.log)
// F07 (E3) — ดาวน์โหลด Excel ของเอกสาร 1 ฉบับ
//   endpoint คืนไฟล์เป็น binary จึงต้องอ่านเป็น arraybuffer แล้วแปลงเป็น Blob
//   กรณีไม่สำเร็จ server คืน JSON { success:false, message } มาแทนไฟล์ ซึ่งยังเป็น arraybuffer อยู่
//   จึงต้องแปลงกลับเป็นข้อความก่อนอ่าน message (ไม่งั้นผู้ใช้จะเห็น popup ว่างเปล่า)
//   pattern การดึงชื่อไฟล์: เหมือน FormSummaryStockGroupPreview.vue และ Report/Barcodes.vue:1014-1034
function downloadDocumentExcel(headerId, accessToken) {
  KTApp.blockPage({
    opacity: 0.05,
    message: "กำลังสร้างไฟล์ Excel กรุณารอสักครู่...",
  });

  axios({
    method: "post",
    url: "/Api/FormSummaryStock/ExportExcel",
    responseType: "arraybuffer",
    data: { headerId: headerId },
    headers: { Authorization: "Bearer " + accessToken },
  })
    .then(function(response) {
      var contentType = response.headers["content-type"] || "";

      // server ปฏิเสธ (หมดอายุ / ไม่มีสิทธิ์ / ไม่มีข้อมูล) → เป็น JSON ไม่ใช่ไฟล์
      if (contentType.indexOf("application/json") !== -1) {
        var text = "";
        try {
          text = new TextDecoder("utf-8").decode(new Uint8Array(response.data));
        } catch (e) {
          text = "";
        }
        var message = "ไม่สามารถ Export Excel ได้";
        try {
          var parsed = JSON.parse(text);
          if (parsed && parsed.message) message = parsed.message;
        } catch (e) {
          // ปล่อยข้อความเริ่มต้นไว้
        }
        Swal.fire("ไม่สามารถ Export ได้", message, "warning");
        return;
      }

      var filename = "";
      var disposition = response.headers["content-disposition"];
      if (disposition && disposition.indexOf("attachment") !== -1) {
        // ดึงชื่อไฟล์จาก Content-Disposition โดยไม่ใช้ regex
        // (หลีกเลี่ยงปัญหา escape ของ \n ในไฟล์ .vue ซึ่งเคยทำให้ bundle พัง)
        var marker = "filename=";
        var at = disposition.indexOf(marker);
        if (at !== -1) {
          filename = disposition.substring(at + marker.length);
          var semi = filename.indexOf(";");
          if (semi !== -1) filename = filename.substring(0, semi);
          filename = filename.trim().replace(/^["']|["']$/g, "");
        }
      }

      var blob = new Blob([response.data], { type: contentType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURIComponent(filename);
      link.click();
    })
    .catch(function() {
      Swal.fire("เกิดข้อผิดพลาด", "สร้างไฟล์ Excel ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
    })
    .then(function() {
      KTApp.unblockPage();
    });
}

// F06 (E1) — เปิดฟอร์ม PDF ของเอกสาร 1 ฉบับ
//   โครงเดียวกับ downloadDocumentExcel ด้านบน — endpoint ต้องการ Bearer token
//   จึงยิงด้วย axios แล้วแปลงเป็น blob ไม่ใช้ <a href> ที่ไม่แนบ header
//
// FS-035 — spec §F (L1495-1499) ระบุว่าปุ่มนี้คือ "เปิดดูก่อนพิมพ์" ไม่ใช่ดาวน์โหลดทันที
//   เปิดแท็บเปล่าทันทีใน user gesture ก่อน (กัน popup blocker) แล้วค่อยชี้ไปที่ blob เมื่อไฟล์มา
//   หน้ารายละเอียด (FormSummaryStockDetail.vue) ใช้กติกาเดียวกัน — แก้ที่ไหนต้องแก้คู่กัน
function downloadDocumentPdf(headerId, accessToken) {
  // ต้องเรียก window.open ตรงนี้ ไม่ใช่ใน .then() — เบราว์เซอร์อนุญาตเฉพาะที่เกิดจากการกดของผู้ใช้
  var previewTab = window.open("", "_blank");
  if (previewTab && previewTab.document) {
    previewTab.document.write(
      '<!doctype html><meta charset="utf-8">' +
        "<title>กำลังเตรียมเอกสาร</title>" +
        '<body style="font-family:sans-serif;padding:24px">' +
        "กำลังสร้างไฟล์ PDF กรุณารอสักครู่...</body>"
    );
  }

  // FS-133 — เปิดแท็บได้ → ขอตั๋วแล้วชี้แท็บไปที่ URL จริง (PdfView/{ตั๋ว}/{ชื่อไฟล์}.pdf)
  //   แถบที่อยู่และชื่อไฟล์ตอนกดดาวน์โหลดในตัวดู PDF จึงเป็นชื่อเอกสาร ไม่ใช่ GUID ของ blob:
  //   โดน popup blocker (ไม่มีแท็บ) → ใช้ทางเดิมด้านล่าง : ดึงไฟล์แล้วเสนอให้ดาวน์โหลดแทน
  if (previewTab) {
    openPdfByTicket(headerId, accessToken, previewTab);
    return;
  }

  KTApp.blockPage({
    opacity: 0.05,
    message: "กำลังสร้างไฟล์ PDF กรุณารอสักครู่...",
  });

  axios({
    method: "post",
    url: "/Api/FormSummaryStock/PrintPdf",
    responseType: "blob",
    data: { headerId: headerId },
    headers: { Authorization: "Bearer " + accessToken },
  })
    .then(function(response) {
      var contentType = response.headers["content-type"] || "";

      if (contentType.indexOf("application/json") !== -1) {
        // server ปฏิเสธ — ปิดแท็บที่เปิดค้างไว้ ไม่ทิ้งหน้าเปล่าให้ผู้ใช้งง
        if (previewTab) previewTab.close();

        var reader = new FileReader();
        reader.onload = function() {
          var message = "พิมพ์เอกสารไม่สำเร็จ";
          try {
            var parsed = JSON.parse(reader.result);
            if (parsed && parsed.message) message = parsed.message;
          } catch (e) {
            // ใช้ข้อความเริ่มต้น
          }
          Swal.fire("พิมพ์ไม่ได้", message, "warning");
        };
        reader.readAsText(response.data);
        return;
      }

      // FS-035 — บังคับ MIME เป็น application/pdf เพื่อให้เบราว์เซอร์เปิดด้วยตัวอ่าน PDF
      //   ไม่ใช่ถือเป็นไฟล์ให้ดาวน์โหลด
      var blob = new Blob([response.data], { type: "application/pdf" });
      var blobUrl = window.URL.createObjectURL(blob);

      if (previewTab) {
        previewTab.location.href = blobUrl;
      } else {
        // โดน popup blocker — อย่าเงียบ บอกผู้ใช้แล้วให้ทางเลือกดาวน์โหลดแทน
        Swal.fire({
          title: "เบราว์เซอร์บล็อกการเปิดแท็บใหม่",
          html:
            "กรุณาอนุญาต popup ของเว็บไซต์นี้เพื่อเปิดดูเอกสารก่อนพิมพ์<br/>" +
            "หรือกดปุ่มด้านล่างเพื่อดาวน์โหลดไฟล์แทน",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "ดาวน์โหลดไฟล์แทน",
          cancelButtonText: "ปิด",
        }).then(function(result) {
          if (result.value !== true) return;

          var filename = "";
          var disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var marker = "filename=";
            var at = disposition.indexOf(marker);
            if (at !== -1) {
              filename = disposition.substring(at + marker.length);
              var semi = filename.indexOf(";");
              if (semi !== -1) filename = filename.substring(0, semi);
              filename = filename.trim().replace(/^["']|["']$/g, "");
            }
          }

          var link = document.createElement("a");
          link.href = blobUrl;
          link.download = decodeURIComponent(filename) || "เอกสาร.pdf";
          link.click();
        });
      }

      setTimeout(function() {
        window.URL.revokeObjectURL(blobUrl);
      }, 60000);
    })
    .catch(function() {
      if (previewTab) previewTab.close();
      Swal.fire("เกิดข้อผิดพลาด", "พิมพ์เอกสารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
    })
    .then(function() {
      KTApp.unblockPage();
    });
}

// FS-133 — ขอตั๋วเปิด PDF (ตรวจสิทธิ์ชุดเดียวกับ PrintPdf) แล้วเปิดในแท็บที่เตรียมไว้
//   ตั๋วอายุ 5 นาที — หมดอายุแล้วแท็บจะแสดงหน้าแจ้งพร้อมปุ่ม "ไปที่เอกสาร" (server ทำ)
//   หน้ารายละเอียด (FormSummaryStockDetail.vue) ใช้กติกาเดียวกัน — แก้ที่ไหนต้องแก้คู่กัน
function openPdfByTicket(headerId, accessToken, previewTab) {
  KTApp.blockPage({ opacity: 0.05, message: "กำลังเปิดเอกสาร PDF..." });

  axios({
    method: "post",
    url: "/Api/FormSummaryStock/PdfTicket",
    data: { headerId: headerId },
    headers: { Authorization: "Bearer " + accessToken },
  })
    .then(function(response) {
      var data = response.data || {};
      if (!data.success || !data.url) {
        previewTab.close();
        Swal.fire("พิมพ์ไม่ได้", data.message || "พิมพ์เอกสารไม่สำเร็จ", "warning");
        return;
      }
      previewTab.location.href = data.url;
    })
    .catch(function() {
      previewTab.close();
      Swal.fire("เกิดข้อผิดพลาด", "พิมพ์เอกสารไม่สำเร็จ กรุณาลองใหม่อีกครั้ง", "error");
    })
    .then(function() {
      KTApp.unblockPage();
    });
}

function showUnderDevelopment(featureName) {
  Swal.fire("อยู่ระหว่างพัฒนา", "ฟังก์ชัน " + featureName + " อยู่ระหว่างพัฒนา", "info");
}

// ลบใบงาน = Soft Delete (is_deleted = 1) — ยืนยัน 1 ครั้ง แล้ว POST /Api/FormSummaryStock/Delete
// เอกสารระบุ: ใบงานหายจากรายการแต่ข้อมูลยังอยู่ในฐานข้อมูล กู้คืนต้องติดต่อพนักงาน SBP เท่านั้น
function deleteFormSummaryStock(ctx) {
  let self = ctx;
  let documentNo = self.data && self.data.documentNo ? self.data.documentNo : "";

  Swal.fire({
    title: "ยืนยันการลบใบงาน",
    type: "warning",
    html:
      "ต้องการลบใบงานเลขที่ <strong>" + documentNo + "</strong> ใช่หรือไม่?<br/>" +
      "<small class='text-muted'>ใบงานจะหายจากรายการทันที หากต้องการกู้คืนต้องติดต่อพนักงาน SBP เท่านั้น</small>",
    showCancelButton: true,
    confirmButtonText: "ยืนยันลบ",
    cancelButtonText: "ยกเลิก",
    showLoaderOnConfirm: true,
  }).then((result) => {
    if (result.value) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังลบข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post(
          "/Api/FormSummaryStock/Delete",
          { id: self.data.id },
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        )
        .then(function(response) {
          if (response.data.success) {
            self.$parent.reloadDataTable();
            Swal.fire("สำเร็จ", "ลบข้อมูลสำเร็จ", "success");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          var errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "เกิดข้อผิดพลาด";
          Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    }
  });
}

// ข้อความ tooltip ของปุ่ม Excel เมื่อรายละเอียดบาร์โค้ดหมดอายุ — คำต่อคำตาม CR-Features.md F02/F09
// จำนวนไฟล์แนบสูงสุดต่อเอกสาร — ตรงกับฝั่ง server (FormSummaryStockAttachmentRules)
const MAX_ATTACHMENTS = 5;

const EXCEL_EXPIRED_TOOLTIP =
  "ไม่สามารถ Export ข้อมูลได้ เนื่องจากข้อมูลรายละเอียดบาร์โค้ดถูกลบไปแล้ว (ระบบเก็บข้อมูล 2 ปีนับจากวันบันทึกเอกสาร)";

// Row actions — 5 ปุ่มตาม CR-Features.md F02:
//   ดูรายละเอียด / PDF / Excel / แนบไฟล์เอกสาร (แดง = 0 ไฟล์, เขียว = มีไฟล์ ≥ 1) / ลบ
// สีปุ่มแนบไฟล์อ่านจาก data.attachmentCount ที่ API ค้นหาส่งมาพร้อมแถว — ไม่ยิง API รายแถว
//
// F09 — ปุ่ม Excel เทาและกดไม่ได้เมื่อ data.isExcelAvailable = false
//   ตั้งใจไม่ใส่ class "disabled" ของ Bootstrap 4 เพราะ a.btn.disabled ตั้ง pointer-events: none
//   ซึ่งจะทำให้ tooltip (title) ไม่ขึ้นตอน hover — แต่ spec บังคับว่าต้องมี tooltip อธิบายเหตุผล
//   จึงใช้ aria-disabled + ทำให้จาง แล้วกันการกดจริงที่ method exportExcel() แทน
//   + บรรทัด "หมดอายุ Export Excel วว/ดด/ปปปป" ใต้ปุ่มคำสั่งทุกแถว
//     ใช้สีเทาปกติ "ทุกสถานะ" ไม่แยกสี/พื้นแถวตามสถานะ (spec ระบุชัด — ปุ่ม Excel กับ filter
//     เป็นตัวบอกสถานะอยู่แล้ว)
// F16 — ปุ่มลบแสดงเมื่อ data.canDelete = true เท่านั้น (server คำนวณมาให้)
//   การซ่อนปุ่มเป็นแค่ UX — ด่านจริงอยู่ที่ DeleteFormSummaryStockCommandHandler
let FormSummaryStockActions = Vue.extend({
  template: `
  <div>
    <!-- QA 08/10/2026 เรื่องที่ 3 — คอลัมน์ "คำสั่ง" เป็นไอคอนล้วน + tooltip
         (spec ฉบับเซ็นถูก BA เพิ่มหัวข้อ I เมื่อ 08/10/2026 แทนที่ FS-005 ที่ให้เป็นปุ่มมีข้อความ)

         QA เรื่องที่ 16 — Action Button Design System: วงกลม sm 28px · สีตามความหมาย
           🔵 ดู · 🟠 พิมพ์ PDF · 🟢 Excel / แนบไฟล์ (มีไฟล์) · 🔴 ลบ / แนบไฟล์ (0/5) · Excel หมดอายุ = inactive เทา
           FS-079 (13/10/2026) — ผู้ใช้สั่งกลับมาใช้แบบนี้ ยกเลิก style /Jobs ของ FS-071
           ไอคอนตามรายงาน: ถังขยะ fa-trash (ไม่ใช่ la-trash ของ FS-063)

         ⚠ ทุกปุ่มต้องมี title เสมอ — เป็นทั้ง tooltip ให้ผู้ใช้ (เกณฑ์ของเรื่องที่ 3) และ selector ของเทส
         data-test ใส่ไว้ให้เทสจับปุ่มได้โดยไม่ผูกกับคลาสหน้าตา -->
    <div class="fss-actions fss-act-group">
      <a href="#" @click.prevent="viewDocument"
         class="fss-act fss-act--sm fss-act--blue"
         data-test="fss-row-view"
         title="ดูรายละเอียด">
        <i class="fas fa-search"></i>
      </a>
      <a href="#" @click.prevent="exportPdf"
         class="fss-act fss-act--sm fss-act--orange"
         data-test="fss-row-pdf"
         title="พิมพ์ PDF">
        <i class="fas fa-print"></i>
      </a>
      <a href="#" @click.prevent="exportExcel"
         class="fss-act fss-act--sm fss-act--green"
         :class="{ 'fss-act--disabled': !excelAvailable }"
         data-test="fss-row-excel"
         :aria-disabled="!excelAvailable"
         :title="excelTitle">
        <i class="fas fa-file-excel"></i>
      </a>
      <a href="#" @click.prevent="openAttachment"
         class="fss-act fss-act--sm"
         :class="hasAttachment ? 'fss-act--green fss-attach-has' : 'fss-act--red'"
         data-test="fss-row-attach"
         :title="attachmentTitle">
        <i class="fas fa-paperclip"></i>
      </a>
      <a v-if="showDelete" href="#" @click.prevent="deleteDocument"
         class="fss-act fss-act--sm fss-act--red"
         data-test="fss-row-delete"
         title="ลบ">
        <i class="fas fa-trash"></i>
      </a>
    </div>
    <!-- design ให้เน้นคำเตือนด้วยสีแดง ส่วนวันที่เป็นสีปกติ จะได้อ่านวันที่ง่าย
         ไม่จมไปกับสีแดงทั้งบรรทัด -->
    <div v-if="excelExpireDateText" class="fss-expire-line">
      <span class="fss-expire-warn">⚠ หมดอายุ Export Excel</span>
      <span class="fss-expire-date">{{ excelExpireDateText }}</span>
    </div>
  </div>`,
  props: ['canEdit'],
  computed: {
    fileCount: function() {
      return this.data && this.data.attachmentCount ? this.data.attachmentCount : 0;
    },
    hasAttachment: function() {
      return this.fileCount > 0;
    },
    attachmentTitle: function() {
      // QA เรื่องที่ 3 — ปุ่มเป็นไอคอนล้วนแล้ว tooltip จึงต้องบอกทั้งชื่อและจำนวน
      return "แนบไฟล์เอกสาร (" + this.fileCount + "/" + MAX_ATTACHMENTS + ")";
    },
    // F09 — สถานะมาจาก server เสมอ (นาฬิกาเครื่อง client เชื่อไม่ได้)
    // ไม่ส่งค่ามา = ถือว่ายัง export ได้ เพื่อไม่ให้ใบเก่าถูกล็อคโดยไม่ตั้งใจ
    excelAvailable: function() {
      return !this.data || this.data.isExcelAvailable !== false;
    },
    excelTitle: function() {
      return this.excelAvailable
        ? "Export Excel (รายละเอียดบาร์โค้ด)"
        : EXCEL_EXPIRED_TOOLTIP;
    },
    // บรรทัดใต้ปุ่มคำสั่ง — ซ่อนเมื่อใบนั้นยังไม่มีวันหมดอายุ (ExcelExpireDate = NULL)
    // แยกวันที่ออกจากข้อความเตือน เพราะ design ให้คนละสี
    excelExpireDateText: function() {
      if (!this.data || !this.data.excelExpireDate) return "";
      return moment(this.data.excelExpireDate).format("DD/MM/YYYY");
    },
    // F16 — ปุ่มลบต้องผ่านทั้งสิทธิ์ใช้งานหน้าจอ (canEdit) และสิทธิ์ลบรายแถว (canDelete)
    // ไม่ส่ง canDelete มา = ไม่แสดงปุ่ม (ปฏิเสธไว้ก่อนปลอดภัยกว่า)
    showDelete: function() {
      return this.canEdit === true && !!this.data && this.data.canDelete === true;
    },
  },
  methods: {
    viewDocument: function() {
      // URL ใบที่บันทึกแล้ว = /PrintSummary/Barcodes/{DocNo} (CR-Features.md F05)
      router.push({ path: `/PrintSummary/Barcodes/${this.data.documentNo}` });
    },
    // F06 (E1) — พิมพ์ฟอร์ม PDF ของแถวนี้
    exportPdf: function() {
      if (!this.data || !this.data.id) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }
      downloadDocumentPdf(this.data.id, this.$root.user.access_token);
    },
    // F07 (E3) — Export Excel รายละเอียดบาร์โค้ด 46 คอลัมน์ จาก snapshot ของใบนี้
    exportExcel: function() {
      // F09 — หมดอายุแล้วต้องกดไม่ได้จริง ไม่ใช่แค่ทำให้ปุ่มดูจาง
      // (tooltip บนปุ่มอธิบายเหตุผลอยู่แล้ว จึงไม่เด้ง popup ซ้ำ)
      if (!this.excelAvailable) return;

      if (!this.data || !this.data.id) {
        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบเลขที่อ้างอิงของเอกสารนี้", "error");
        return;
      }

      downloadDocumentExcel(this.data.id, this.$root.user.access_token);
    },
    // F08 — เปิด popup แนบไฟล์เอกสาร (FormSummaryStockAttachmentModal.vue)
    //   component นี้ mount ด้วย { parent: self } ตอน draw.dt → $parent = หน้ารายการที่ถือ modal ไว้
    //   การ reload ตารางหลังปิด popup ทำผ่าน @closed="reloadDataTable()" ที่ template ของหน้ารายการ
    openAttachment: function() {
      // $refs safety — modal อยู่นอก v-if/v-show จึงมีเสมอ แต่กันไว้เผื่อ mount ยังไม่เสร็จ
      var modal =
        this.$parent && this.$parent.$refs
          ? this.$parent.$refs.attachmentModal
          : null;

      if (!modal || typeof modal.open !== "function") {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ไม่สามารถเปิดหน้าต่างแนบไฟล์เอกสารได้ กรุณาโหลดหน้าใหม่อีกครั้ง",
          "error"
        );
        return;
      }

      modal.open(this.data);
    },
    deleteDocument: function() {
      deleteFormSummaryStock(this);
    },
  },
});

export default {
  components: {
    select2,
    // F08 — popup แนบไฟล์เอกสาร (เรียกผ่าน $refs.attachmentModal.open(rowData))
    "form-summary-stock-attachment-modal": FormSummaryStockAttachmentModal,
  },
  computed: {
    // สิทธิ์สร้าง/ลบใบงาน — Profile "พิมพ์เอกสารสรุปข้อมูล" (super_admin ผ่านเสมอผ่าน canShow)
    // ค่าคงที่ตรงกับ SBP.Application/Constants/FORM_SUMMARY_STOCK_ROLE.cs + COMPANY_PROFILE_TYPE.cs
    canEdit: function() {
      return this.$root.canShow([
        ["FORM_SUMMARY_STOCK_ADMIN", "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK"],
        ["FORM_SUMMARY_STOCK_AGENT", "COMPANY_PROFILE_TYPE_FORM_SUMMARY_STOCK"],
      ]);
    },
  },
  data: function() {
    var self = this;

    return {
      // moment object หรือ null — แปลงเป็น "DD/MM/YYYY" ตอนส่งให้ API
      searchDateFrom: null,
      searchDateTo: null,
      // FS-014 — คำค้นเลขที่เอกสาร ("" = ไม่กรอง) · trim ก่อนส่งให้ API
      //   ใช้ "" ไม่ใช่ null เพราะผูกกับ <input> ตรง ๆ (v-model ของ input จะได้ string เสมอ)
      // FS-077 — เวลาที่เริ่มโหลดรอบล่าสุด + เลขรอบ (กัน timer รอบเก่าปลด overlay ของรอบใหม่)
      searchStartedAt: 0,
      searchRound: 0,
      searchDocumentNo: "",
      // null = "ทั้งหมด" (ค่าเริ่มต้นตาม CR-Features.md F02)
      searchAgentCode: null,
      // F09 — null = "ทั้งหมด" · ค่าที่ส่งตรงกับ FormSummaryStockExcelExpiryStatus (ฝั่ง C#)
      searchExcelExpiryStatus: null,
      // FS-004 — null = "ทั้งหมด" · ค่าที่ส่งตรงกับ FormSummaryStockAttachmentStatus (ฝั่ง C#)
      searchAttachmentStatus: null,
      // ตัวเลือก filter "อายุ Export Excel" — สี/สัญลักษณ์อยู่ในตัวเลือกเท่านั้น
      // ไม่นำไปใช้กับข้อความในแถว (spec ระบุชัดว่าแถวใช้สีเทาเหมือนกันทุกสถานะ)
      excelExpiryStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        minimumResultsForSearch: -1,
        data: [
          { id: "ACTIVE", text: "🟢 ยังใช้ได้ปกติ" },
          { id: "NEAR_EXPIRY", text: "🟠 ใกล้หมดอายุ (ภายใน 30 วัน)" },
          { id: "EXPIRED", text: "🔴 หมดอายุแล้ว (ลบข้อมูล)" },
        ],
      },
      // FS-004 — ตัวเลือก filter "สถานะแนบไฟล์เอกสาร" (ข้อความคำต่อคำตาม CR-Features.md F02)
      // ไม่ใส่ตัวเลือก "ทั้งหมด" ในรายการ เพราะใช้ placeholder + allowClear แทน
      // (แพตเทิร์นเดียวกับ excelExpiryStatusOptions ด้านบน — ล้างค่าแล้ว server ถือว่าไม่กรอง)
      attachmentStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        minimumResultsForSearch: -1,
        data: [
          { id: "HAS_FILE", text: "มีเอกสารแนบ" },
          { id: "NO_FILE", text: "ไม่มีเอกสารแนบ" },
        ],
      },
      // Agent Select2 — scoped ajax ฝั่ง server (ตัวแทนที่ user มีสิทธิ์เห็นเท่านั้น)
      // mirror pattern: StockCoverDaysList.vue plantOptions → /Api/StockCoverDayTarget/Select2Plant
      agentOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        ajax: {
          url: "/Api/FormSummaryStock/Select2Agent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      // "ล้างข้อมูล" = ล้างเฉพาะเงื่อนไขค้นหา ไม่ได้ลบข้อมูลจริง
      // FS-014 — ช่องเลขที่เอกสารต้องล้างตรงนี้เท่านั้น พึ่งปุ่ม type="reset" ไม่ได้
      //   formSubmit() ที่ถูกเรียกท้ายเมธอดนี้สั่ง e.preventDefault() ซึ่งยกเลิก default action
      //   ของปุ่ม reset ไปด้วย DOM จึงไม่ถูกล้างเอง (และต่อให้ล้างได้ การ reset ก็ไม่ยิง event
      //   "input" จึงไม่อัปเดต v-model อยู่ดี) ถ้าไม่ล้างตรงนี้ คำค้นเก่าจะยังติดไปกับ payload
      //   ทำให้กด "ล้างข้อมูล" แล้วผลลัพธ์ยังว่างอยู่ทั้งที่ filter อื่นถูกล้างหมดแล้ว
      this.searchDocumentNo = "";
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchAgentCode = null;
      this.searchExcelExpiryStatus = null;
      this.searchAttachmentStatus = null;

      // $refs safety — element อยู่ใน v-show (ไม่ใช่ v-if) จึงมีเสมอ แต่กันไว้เผื่อ reset ถูกเรียกก่อน mount เสร็จ
      if (this.$refs.fssList_dateFrom) {
        $(this.$refs.fssList_dateFrom).datepicker("update", null);
      }
      if (this.$refs.fssList_dateTo) {
        $(this.$refs.fssList_dateTo).datepicker("update", null);
      }
      $("#fssList_agentCode").val("").trigger("change");
      // select2 แบบ data ในตัว ใช้ .val(null) ตาม pattern ของ BudgetPlanJobList.vue:393
      // (ต่างจาก agent select2 ด้านบนที่เป็น ajax จึงใช้ .val(""))
      $("#fssList_excelExpiryStatus").val(null).trigger("change");
      $("#fssList_attachmentStatus").val(null).trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      if (e) e.preventDefault();

      // ตรวจช่วงวันที่ให้ผู้ใช้เห็นทันที (ข้อความไทย) แทนการยิงค้นหาที่ได้ผลลัพธ์ว่างเปล่า
      if (
        this.searchDateFrom &&
        this.searchDateTo &&
        this.searchDateFrom.isAfter(this.searchDateTo, "day")
      ) {
        Swal.fire("ข้อมูลไม่ถูกต้อง", "กรุณาระบุวันที่บันทึก (จาก) ไม่เกินวันที่บันทึก (ถึง)", "warning");
        return;
      }

      // FS-014 — เอา `table.search();` (ไม่ส่งอาร์กิวเมนต์) ออก เพราะเป็น dead code:
      //   .search() แบบไม่มีพารามิเตอร์ของ DataTables เป็น "getter" คืนคำค้นปัจจุบัน ไม่ได้ตั้งค่าใด ๆ
      //   และหน้านี้ไม่มีกล่องค้นหาของ DataTables อยู่แล้ว (dom ด้านล่างไม่มีตัว `f`)
      //   คำค้นเลขที่เอกสารส่งผ่าน payload ของเราเอง (DocumentNo) ใน ajax.data ไม่ใช่ผ่าน global search
      //   -> เหลือแค่ draw() พอ · draw() แบบไม่ใส่อาร์กิวเมนต์ = reset paging กลับหน้า 1 ให้ด้วย
      //      ซึ่งเป็นพฤติกรรมที่ต้องการเมื่อเปลี่ยนเงื่อนไขค้นหา
      var table = $("#formSummaryStockTable").DataTable();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#formSummaryStockTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    goToCreate: function() {
      router.push({ path: "/PrintSummary/Barcodes/New" });
    },
  },
  // FS-125 (19/10/2026) — กลับมาหน้ารายการจากหน้าลูก (รายละเอียด / สร้างเอกสาร) ด้วย router
  //   หน้ารายการไม่ถูก mount ใหม่ (หน้าลูกเป็น child route · portlet ถูกซ่อนด้วย v-show) จึงต้อง:
  //   1. reload ข้อมูลแถว — จำนวนไฟล์แนบ (สีปุ่มแนบ) ที่เปลี่ยนในหน้ารายละเอียดจะได้ตรง · คงหน้า/เงื่อนไขค้นหาเดิม
  //   2. คำนวณความกว้างคอลัมน์ใหม่ — ถ้าตารางถูกสร้างตอนซ่อนอยู่ (เปิดหน้ารายละเอียดตรงจากลิงก์ก่อน)
  //      DataTables ตั้งความกว้าง th เป็น 0px คอลัมน์ "คำสั่ง" จึงขยายกินที่เหลือ (~584px แทน 230px)
  watch: {
    $route: function(to, from) {
      if (to.path !== "/PrintSummary/Barcodes" || !from || from.path === to.path) return;

      this.$nextTick(function() {
        var $table = $("#formSummaryStockTable");
        if (!$.fn.DataTable.isDataTable($table)) return;

        var table = $table.DataTable();
        table.columns.adjust();
        if (table.responsive) table.responsive.recalc();
        table.ajax.reload(null, false);
      });
    },
  },
  async mounted() {
    let self = this;

    await this.$nextTick();

    // ── Datepicker ช่วงวันที่บันทึก ─────────────────────────────────────────
    // mirror pattern: SBP.Web/App/Components/Job/JobList.vue:1359-1401 (bootstrap-datepicker global)
    // ไม่กำหนด minDate/maxDate เพราะเป็นการค้นหาเอกสารย้อนหลัง
    var datepickerOptions = {
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
    };

    if (self.$refs.fssList_dateFrom) {
      $(self.$refs.fssList_dateFrom)
        .datepicker(datepickerOptions)
        .on("changeDate", function(e) {
          self.searchDateFrom = e.dates.length != 0 ? moment(e.date) : null;
        });
    }

    if (self.$refs.fssList_dateTo) {
      $(self.$refs.fssList_dateTo)
        .datepicker(datepickerOptions)
        .on("changeDate", function(e) {
          self.searchDateTo = e.dates.length != 0 ? moment(e.date) : null;
        });
    }

    // ── Datatable (server-side) ────────────────────────────────────────────
    $.fn.dataTable.ext.errMode = "none";
    var table = $("#formSummaryStockTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        // FS-014 — เอา `searchDelay: 500` ออกพร้อมกับ table.search() ที่เป็น dead code
        //   หน้านี้ไม่ได้เปิดกล่องค้นหาของ DataTables (dom ด้านล่างไม่มีตัว `f`)
        //   ตั้ง searchDelay ไว้จึงไม่มีผลอะไร และทำให้คนอ่านทีหลังเข้าใจผิดว่ามี global search อยู่
        //   การค้นหาเลขที่เอกสารใช้ช่อง fssList_documentNo + payload DocumentNo แทน
        // server บังคับเรียงใบใหม่สุดขึ้นก่อนเสมอ (SnapshotDate DESC, Id DESC) → ปิด sort ฝั่ง client
        ordering: false,
        ajax: {
          url: "/Api/FormSummaryStock/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                // FS-014 — คำค้นเลขที่เอกสาร · trim ก่อนส่ง (ผู้ใช้ copy จาก Excel/PDF มักติดช่องว่าง
                //   หรือขึ้นบรรทัดใหม่มาด้วย) · ว่าง = null เพื่อให้ server ถือว่าไม่กรอง
                //   server กรองด้วย Contains ก่อน CountAsync จึงได้ยอดรวม/จำนวนหน้าถูกต้อง
                DocumentNo: self.searchDocumentNo ? self.searchDocumentNo.trim() : null,
                DateFrom: self.searchDateFrom ? self.searchDateFrom.format(DATE_FORMAT) : null,
                DateTo: self.searchDateTo ? self.searchDateTo.format(DATE_FORMAT) : null,
                AgentCode: self.searchAgentCode,
                // F09 — null/"" = ทั้งหมด (server ถือว่าไม่กรอง)
                ExcelExpiryStatus: self.searchExcelExpiryStatus,
                // FS-004 — null/"" = ทั้งหมด (server กรองด้วย EXISTS ก่อนนับ/แบ่งหน้า)
                AttachmentStatus: self.searchAttachmentStatus,
              })
            );
          },
        },
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [50, 100, 200, 500],
        pageLength: 100,
        // QA 08/10/2026 เรื่องที่ 4 — ข้อความของตารางต้องเป็นภาษาไทยทั้งหมด
        //   ของเดิมปล่อยให้ DataTables ใช้ค่าเริ่มต้นภาษาอังกฤษ
        //   ผู้ใช้ค้นหาไม่เจอแล้วเห็น "No data available in table"
        // เรื่องที่ 7 — ระหว่างรอผลให้ขึ้น "กำลังค้นหา..." แทน "Processing..."
        language: {
          lengthMenu: "แสดง _MENU_ แถว",
          emptyTable: "ไม่พบข้อมูลที่ค้นหา",
          zeroRecords: "ไม่พบข้อมูลที่ค้นหา",
          info: "แสดง _START_ ถึง _END_ จากทั้งหมด _TOTAL_ รายการ",
          infoEmpty: "ไม่มีรายการที่ตรงกับเงื่อนไข",
          infoFiltered: "(กรองจากทั้งหมด _MAX_ รายการ)",
          processing: "กำลังค้นหา...",
          loadingRecords: "กำลังโหลดข้อมูล...",
          paginate: {
            first: "หน้าแรก",
            last: "หน้าสุดท้าย",
            next: "ถัดไป",
            previous: "ก่อนหน้า",
          },
        },
        columns: [
          {
            data: "documentNo",
            className: "text-center",
            width: "12%",
            render: function(data, type, full, meta) {
              return data ? data : "-";
            },
          },
          {
            data: "snapshotDate",
            className: "text-center",
            width: "13%",
            render: function(data, type, full, meta) {
              return data ? moment(data).format("DD/MM/YYYY HH:mm") : "-";
            },
          },
          {
            data: "agentName",
            className: "text-left",
            width: "38%",
            // FS-062 — mockup หน้ารายการเขียนรูปแบบ "[รหัส] ชื่อ"
            //   เช่น [1000297] บริษัท สมุย เบียร์ จำกัด
            //   ของเดิมแสดงแต่ชื่อ ไม่มีรหัสนำหน้า
            //   รูปแบบเดียวกับหน้าสรุปผลขั้นที่ 6 ที่แก้ไปแล้วตอน FS-053 ข้อ 1
            render: function(data, type, full, meta) {
              var code = full.agentCode || full.headAgentCode;

              // ครบทั้งคู่ = รูปแบบเต็มตาม mockup
              if (code && data) return "[" + code + "] " + data;

              // มีรหัสแต่ snapshot ชื่อว่าง — แสดงรหัสอย่างเดียว
              //   ห้ามต่อ "-" ท้ายวงเล็บ จะกลายเป็น "[1000836] -" ซึ่งอ่านแล้วสับสน
              if (code) return "[" + code + "]";

              // ไม่มีรหัส (ข้อมูลเก่าที่ไม่ได้ stamp ไว้) — เหลือแค่ชื่อ ไม่ใส่วงเล็บว่าง
              if (data) return data;

              return "-";
            },
          },
          {
            data: "createdByName",
            className: "text-center",
            width: "37%",
            render: function(data, type, full, meta) {
              return data ? data : "-";
            },
          },
          {
            data: "id",
            className: "text-center",
            width: "230px",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        // FS-077 — เริ่มจับเวลาขั้นต่ำ 1 วินาที (ยิง ajax 1 ครั้ง = 1 รอบ)
        self.searchRound += 1;
        self.searchStartedAt = Date.now();
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function(e, settings, techNote, message) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function() {
        // FS-077 — overlay ต้องค้างอย่างน้อย 1 วินาที (ของเดิมตอบเร็วจนขึ้นแว้บเดียวแล้วหาย)
        //   ตอบเร็วกว่า 1 วินาที → รอจนครบค่อย unblock · ช้ากว่านั้น → unblock ทันที
        //   round กันกรณีโหลดซ้อน (เปลี่ยนหน้าระหว่างรอ) ไม่ให้ timer รอบเก่ามาปลด overlay ของรอบใหม่
        var round = self.searchRound;
        var remain = SEARCH_MIN_LOADING_MS - (Date.now() - self.searchStartedAt);
        if (remain <= 0) {
          KTApp.unblock(self.$refs.searchForm);
          return;
        }
        setTimeout(function() {
          if (round === self.searchRound) KTApp.unblock(self.$refs.searchForm);
        }, remain);
      })
      .on("draw.dt", function() {
        // scope selector ไว้ในตารางนี้เท่านั้น — หน้าลูก (<router-view/>) อยู่ใน DOM พร้อมกัน
        // จึงห้ามใช้ $(".actions") แบบ global เพราะอาจ mount ทับ action ของหน้าลูก
        $("#formSummaryStockTable .actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new FormSummaryStockActions({
              data: { data },
              parent: self,
              propsData: { canEdit: self.canEdit },
            }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss">
.select2,
.select2-dropdown {
  font-size: 1rem !important;
}

/* FS-005 — ปุ่มคำสั่งแบบ "มีข้อความ" ในคอลัมน์ "คำสั่ง"
   <style> ของไฟล์ .vue ในโปรเจกต์นี้ไม่ได้ scoped จึงต้องจำกัด selector ไว้ใต้ตารางนี้เท่านั้น
   ไม่งั้นจะไปทับปุ่มของหน้าจออื่นที่โหลดอยู่ใน SPA เดียวกัน */
#formSummaryStockTable {
  /* FS-084 — ล็อคคอลัมน์ "คำสั่ง" ไว้ 230px
     width ใน th/options อย่างเดียวไม่พอ: 4 คอลัมน์แรกเป็น % รวมกัน 100% browser จึงหดคอลัมน์ px ลงเหลือ ~187px
     min/max-width บังคับให้ตารางแบ่งพื้นที่ที่เหลือให้ 4 คอลัมน์แรกแทน */
  > thead > tr > th:last-child,
  > tbody > tr > td:last-child {
    width: 230px;
    min-width: 230px;
    max-width: 230px;
  }

  /* FS-089 — คอลัมน์ตัวแทนจำหน่ายจัดชิดซ้าย ข้อความเคยติดเส้นจนวงเล็บ "[" ของรหัสถูกเส้นทับครึ่งตัว */
  > tbody > tr > td:nth-child(3) {
    padding-left: 12px;
  }

  /* 1 บรรทัดของปุ่ม — flex + wrap เพื่อให้จอแคบปุ่มไหลลงบรรทัดถัดไปแทนที่จะดันตารางล้น */
  .fss-actions {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  /* ปุ่มเล็กลงกว่า btn-sm ปกติ เพราะต้องใส่ข้อความไทย 5 ปุ่มในคอลัมน์เดียว
     nowrap = ห้ามตัดคำกลางปุ่ม ไม่งั้นความสูงปุ่มในแถวเดียวกันจะไม่เท่ากัน */
  .fss-action-btn {
    margin: 2px;
    padding: 4px 10px;
    font-size: 0.85rem;
    line-height: 1.2;
    white-space: nowrap;
  }

  /* บรรทัดแจ้งวันหมดอายุ — design ให้คำเตือนเป็นสีแดง ส่วนวันที่เป็นสีปกติ
     ถ้าแดงทั้งบรรทัดจะอ่านวันที่ยาก เพราะสายตาไปจับคำเตือนก่อน */
  .fss-expire-line {
    font-size: 0.8rem;
    white-space: nowrap;
    margin-top: 2px;
  }

  .fss-expire-warn {
    color: #fd397a;
    font-weight: 500;
  }

  .fss-expire-date {
    color: #48465b;
  }

  /* QA 08/10/2026 เรื่องที่ 16 — เขียวเข้ม #1b7a3d ที่เคยซ้อนทับไว้ถูกตัดออก
     mockup (03_MOCKUPS/download_icon_mockup.html) ระบุชัดว่าปุ่มแนบไฟล์ตอน "มีไฟล์แล้ว"
     ใช้เขียวชุดเดียวกับ Design System (#10B981) — ไม่มีเขียวตัวที่ 5 ในชุด
     เดิมที่ต้องซ้อนทับเพราะ btn-success ของธีมจางเกินไป ตอนนี้ไม่ใช้ btn-success แล้ว
     คลาส .fss-attach-has ยังติดไว้เป็นหมุดให้เทสเดิมอ้างได้ แต่ไม่มีสีของตัวเอง */
}
</style>



// WEBPACK FOOTER //
// App/Components/PrintSummary/FormSummaryStockList.vue